import React from 'react';
import {StyleProp, TextStyle} from 'react-native';

import Text from '/component/base/Text';
import testProperties from '/util/testing/testProperties';
interface TaskItemDescriptionComponentProps {
  description: StringConstructor;
  style: StyleProp<TextStyle>;
  testID: string;
}

export const TaskItemDescriptionComponent: React.FC<
  TaskItemDescriptionComponentProps
> = ({description, style, testID}) => {
  return (
    <Text
      variant="button"
      style={style}
      {...testProperties(testID ?? 'task-description')}>
      {description}
    </Text>
  );
};
